<div class="row">
    <div class="col-md-12 app-toolbar">
        <mat-toolbar>
            <span *ngFor="let tool of getTools()" [ngClass]="tool.isVisible() && !tool.layerTool ? 'tool-visible' : 'tool-novisible'">
                <mat-icon *ngIf="tool.isVisible() && !tool.layerTool" [ngClass]="tool.enabled ? 'tool-on' : 'tool-off'" (click)="toogleTool(tool)" title="{{tool.title}}" class="btn-icon" aria-hidden="false" aria-label="{{tool.title}}">{{tool.icon}}</mat-icon>
            </span>
        </mat-toolbar>
    </div>
</div>